import { type ReactNode, Suspense } from "react";
import { twMerge } from "tailwind-merge";

import { ToastRegion } from "@/components/base/toast";
import { Footer } from "@/components/footer";
import { ImpersonatorControls } from "@/components/impersonator/controls";
import { Navbar } from "@/components/navbar";
import { NewsletterForm } from "@/components/newsletter-form";
import { SideNav } from "@/components/side-nav";
import { SideNavProvider } from "@/components/side-nav-context";

export type DefaultLayoutProps = {
  classNames?: { content?: string };
  children: ReactNode;
};

export function DefaultLayout({
  classNames = { content: "pt-18 px-3 pb-12 space-y-12 w-full" },
  children,
}: DefaultLayoutProps) {
  return (
    <SideNavProvider>
      <div className="bg-content-background text-content-foreground flex min-h-screen w-full flex-col">
        <header>
          <Navbar />
        </header>

        <div className={twMerge("relative flex-1", classNames.content)}>
          {children}
        </div>

        <NewsletterForm />
        <Footer />
        <ImpersonatorControls />
        <ToastRegion />
        <Suspense fallback={null}>
          <SideNav />
        </Suspense>
      </div>
    </SideNavProvider>
  );
}
